import { MEMBERS_WITH_OPEN_ENTRY_COUNT_QUERY } from 'apollo/queries/member-queries';
import { useApolloPaging } from 'hooks';
import { isNil } from 'lodash';
import { useMemo, useState } from 'react';
import { IMember } from 'types';
import ICursorable from 'types/Cursorable';
import MemberPermission from 'types/enum/MemberPermission';
import { populateOpenTimeEntryField } from 'utils/memberUtils';

interface IDashboardClockStatusInfo {
  employeeCount: number;
  clockedInCount: number;
  clockedOutCount: number;
  onBreakCount: number;
}

export default function useDashboardClockStatus() {
  const { getAll } = useApolloPaging();
  const [error, setError] = useState<string | null>(null);
  const [aggregatedInfo, setAggregatedInfo] = useState<IDashboardClockStatusInfo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useMemo(async () => {
    setIsLoading(true);
    try {
      await getAll<IMember & ICursorable>('members', {
        query: MEMBERS_WITH_OPEN_ENTRY_COUNT_QUERY,
        variables: {
          first: 500,
          filter: {
            permissions: { permissions: MemberPermission.TIME_EVENTS, operationType: 'and' },
            archivedOn: { isNull: true },
          },
        },
        fetchPolicy: 'network-only',
      })
        .then((response) => {
          const members = populateOpenTimeEntryField(response);

          setIsLoading(false);
          setAggregatedInfo({
            employeeCount: members.length,
            clockedInCount: members.filter((member) => member.openTimeEntry && isNil(member.openTimeEntry?.openBreak))
              .length,
            clockedOutCount: members.filter((member) => isNil(member.openTimeEntry)).length,
            onBreakCount: members.filter((member) => member.openTimeEntry && !isNil(member.openTimeEntry?.openBreak))
              .length,
          });
          setError(null);
        })
        .catch((error) => {
          setIsLoading(false);
          setError(error);
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { aggregatedInfo, error, isLoading };
}
